<template>
  <div class="select-typeahead-container" v-bind:id="prettyContainerUid">
    <select style="width: 100%; display: block" v-bind:id="prettyUid"></select>
  </div>
</template>

<script>
import ToastrType from "../toastr-types.interface";

export default {
  name: "select-typeahead",

  props: {
    placeholder: {
      type: String,
      default: "Select an option",
    },

    model: {
      type: String,
      required: true,
    },

    modelField: {
      type: String,
      default: false,
    },

    minLength: {
      type: Number,
      default: 2,
    },

    multiple: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      prettyUid: "select-typeahead-" + this._uid,
      prettyContainerUid: "select-typeahead-container-" + this._uid,
      selected: [],
      placeholderInterval: null,
      currentRequest: null,
    };
  },

  mounted: function () {
    let ctx = this;

    // Setup our select2 instance.

    $(function () {
      jQuery.fn.select2.defaults.set("language--loadingMore", function () {
        return "Scroll to load more...";
      });

      let $select = $("#select-typeahead-" + ctx._uid);

      if (ctx.multiple == true) {
        $select.attr("multiple", "multiple");
      }

      if ($select.length) {
        let $select2Instance = $("#select-typeahead-" + ctx._uid).select2({
          closeOnSelect: true,
          dropdownParent: $("#" + ctx.prettyContainerUid),
          theme: "bootstrap4",
          minimumInputLength: ctx.minLength,
          placeholder: ctx.placeholder,
          ajax: {
            url: `/api/typeaheadsearch/${ctx.model}`,
            data: function (params) {
              let query = {
                search: params.term,
                page: params.page || 1,
                modelField: ctx.modelField,
                timestamp: Date.now(),
              };

              return query;
            },
            transport: function (params, success, failure) {
              // Cancel the previous request if it exists
              if (ctx.currentRequest && ctx.currentRequest.readyState !== 4) {
                ctx.currentRequest.abort();
              }

              ctx.currentRequest = $.ajax(params);

              ctx.currentRequest.done(success);
              ctx.currentRequest.fail(function (xhr) {
                // Don't call failure callback if the request was aborted
                if (xhr.statusText !== "abort") {
                  failure();
                }
              });

              return ctx.currentRequest;
            },
            processResults: function (data) {
              let newData = $.map(data.data, function (obj) {
                if (ctx.modelField == "email" && obj.email.length > 0) {
                  if (obj.status == 1) {
                    obj.text = obj.name + " (" + obj.email + ")";
                  }
                } else {
                  obj.text = obj.title || obj.name;
                }
                return obj;
              });

              let current_page = data.current_page || 1;

              return {
                results: newData,
                pagination: {
                  more: current_page < data.last_page,
                },
              };
            },
          },
        });

        ctx.$emit("selectinstance", $select2Instance);

        let $select2Container = $("#" + ctx.prettyContainerUid);

        if ($select2Container.length) {
          // Styling fixes.
          $select2Instance
            .on("change", function (e) {
              let selectedItems = $select2Instance.val();

              ctx.$emit("input", selectedItems);

              let $select2Container = $("#" + ctx.prettyContainerUid);

              let $resultsDropdown = $select2Container
                .find(".select2-results")
                .parents(".select2-container--open");

              $resultsDropdown.css(
                "margin-top",
                $select2Container
                  .find(".select2-selection__rendered")
                  .outerHeight(),
              );

              ctx.$emit("select-value-change-callback", selectedItems);
            })
            .on("select2:close select2:open", function (e) {
              let $select2Container = $("#" + ctx.prettyContainerUid);

              let $resultsDropdown = $select2Container
                .find(".select2-results")
                .parents(".select2-container--open");

              $resultsDropdown.css(
                "margin-top",
                $select2Container
                  .find(".select2-selection__rendered")
                  .outerHeight(),
              );
            })
            .on("select2:open", function (e) {
              ctx.placeholderInterval = setInterval(function () {
                $select2Container
                  .find(".select2-search__field")
                  .attr("placeholder", ctx.placeholder);
              }, 500);
            })
            .on("select2:close", function (e) {
              clearInterval(ctx.placeholderInterval);
            });

          let $select2SearchField = $select2Container.find(
            ".select2-search__field",
          );

          if ($select2SearchField.length) {
            $select2Container
              .find(".select2-search__field")
              .addClass("form-control");
          }
        }
      } else {
        console.log("[select-typeahead] Element doesnt exist yet:");
        console.log($select);
      }
    });
  },

  watch: {},

  methods: {
    reset() {
      // Cancel any ongoing request when resetting
      if (this.currentRequest && this.currentRequest.readyState !== 4) {
        this.currentRequest.abort();
      }

      this.query = "";
      this.items = [];
      this.noResults = false;
    },
  },
};
</script>
